import { ErrorListResponse, instanceOfErrorListResponse } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useToastCreator } from '../../../../../../../../hooks/useToastCreator';
import { customerConsortiumItemSelectedState } from '../../../../../../../../store/consortium/atom';
import { getCustomerBalance } from '../../../../../../../BatchTicket/services';
import {
  errorBalanceUpdateMessage,
  successBalanceUpdateMessage,
} from '../../../../../../../BatchTicket/utils';
import { CustomerItemDataProps } from '../../../../../../utils/types';

import { Desktop } from './desktop';
import { Mobile } from './mobile';
import { Tablet } from './tablet';

interface IsClosedProps {
  title: string;
}

export interface IsClosedLayoutResponsiveProps {
  data: CustomerItemDataProps | null;
  title: string;
  isLoadingBalance: boolean;
  handleUpdateBalance: () => Promise<void>;
}

export const IsClosed: React.FC<IsClosedProps> = ({ title }) => {
  const currentCustomerSelected = useRecoilValue(customerConsortiumItemSelectedState).current;
  const { showToast, showToastFromError } = useToastCreator(
    'toast-consortium-customer-section-closed-update-balance'
  );

  const [isLoadingBalance, setIsLoadingBalance] = useState(false);
  const [availableBalance, setAvailableBalance] = useState(
    currentCustomerSelected?.availableBalance ?? 0
  );

  const handleUpdateBalance = async () => {
    try {
      setIsLoadingBalance(true);
      const accountNumber = currentCustomerSelected?.accountNumber ?? 0;

      const availableBalanceResponse = await getCustomerBalance(accountNumber);

      if (availableBalanceResponse !== availableBalance) {
        setAvailableBalance(availableBalanceResponse);
      }

      showToast(...successBalanceUpdateMessage, { duration: 3000 });
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        return;
      }

      showToast(...errorBalanceUpdateMessage);
    } finally {
      setIsLoadingBalance(false);
    }
  };

  const params = { title, data: currentCustomerSelected, isLoadingBalance, handleUpdateBalance };

  const layout = useBreakpointValue({
    base: <Mobile {...params} />,
    sm: <Tablet {...params} />,
    lg: <Desktop {...params} />,
  });

  return layout;
};
